<template>
  <v-btn name="logout" class="logout-button" @click="logOut()" v-bind="$attrs"><span v-t="'Sign out'" /></v-btn>
</template>

<script>
import logoutMixin from "@/landing/mixins/logoutMixin";
export default {
  mixins: [logoutMixin],
};</script>
